import React from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';


export interface JcTitleProps extends JcCommonProps {
  readonly title: React.ReactNode;
}


export const JcTitle: React.FunctionComponent<JcTitleProps> = (props: JcTitleProps) => {

  const commonProps = JcUtils.commonProps(props, ["jc-title"]);

  return <h1 {...commonProps}>
    {props.title}
  </h1>;
}
